// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5cfea029","239":"7f73e3bd","455":"f216a2cc"}[chunkId] + ".chunk.js";
};